export default __webpack_public_path__ + "static/SuisseIntl-Medium-WebS-79b7a6f180d912d94720f9143d74e230.woff";